module.exports = __webpack_public_path__ + "img/chain-banner.55abc1d8.png";